import { styled } from '@mui/material';

import { tokens } from '../../../../../../../theme/generated/tokens';
import { WithRef } from '../../../../../../../types';
import { CaretDown, CaretUp, Lock, LockOpen } from '../../../../../../icons';
import { IconProps } from '../../../../../../icons/IconBase';

export const ExpandIcon = ({
  isExpanded,
  ...props
}: IconProps & { isExpanded: boolean }) => {
  const Icon = isExpanded ? CaretUp : CaretDown;
  return <Icon {...props} />;
};

const StyledLockIcon = styled('svg', {
  shouldForwardProp: (prop) => !['as', 'isDisabled'].includes(prop as any),
})<{
  isDisabled?: boolean;
}>(({ isDisabled }) => ({
  color: isDisabled
    ? tokens.theme.disabled.fg
    : tokens.theme.fg.structural.secondary,
  '&:hover': {
    color: !isDisabled ? tokens.theme.fg.structural.primary : undefined,
  },
  cursor: isDisabled ? undefined : 'pointer',
}));

export const LockIcon = ({
  ref,
  isLocked,
  isDisabled,
  onClick,
  ...props
}: WithRef<
  SVGSVGElement,
  IconProps & { isLocked?: boolean; isDisabled?: boolean }
>) => {
  const Icon = isLocked ? Lock : LockOpen;

  return (
    <StyledLockIcon
      as={Icon}
      weight={isLocked ? 'fill' : undefined}
      isDisabled={isDisabled}
      onClick={isDisabled ? undefined : onClick}
      {...props}
      ref={ref}
    />
  );
};

LockIcon.displayName = 'LockIcon';
